export default __webpack_public_path__ + "static/media/5.d81963a9.png";